import { render } from "./ItineraryDetail.vue?vue&type=template&id=599b9fae&scoped=true"
import script from "./ItineraryDetail.vue?vue&type=script&lang=js"
export * from "./ItineraryDetail.vue?vue&type=script&lang=js"

import "./ItineraryDetail.vue?vue&type=style&index=0&id=599b9fae&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-599b9fae"

export default script